import { useEffect } from 'react'

const LOCK_CLASS = 'body-scroll-locked'

/** Prevents background page scroll while a modal/overlay is open. */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return
    document.body.classList.add(LOCK_CLASS)
    return () => document.body.classList.remove(LOCK_CLASS)
  }, [locked])
}
